export default function () {

    const scrollInElements = document.querySelectorAll('[data-scroll]');
    if (scrollInElements && scrollInElements.length) {
        enterLeaveCheck();
        window.addEventListener('load', enterLeaveCheck);
        window.addEventListener('scroll', enterLeaveCheck);
    }


    function enterLeaveCheck() {
        const w = window.innerHeight;
        for(let scrollInElement of scrollInElements) {
            const offset = parseInt(scrollInElement.getAttribute('data-o') ? scrollInElement.getAttribute('data-o') : 0);
            if (isNaN(offset)) {
                offset = 0;
            }
            if (scrollInElement.getBoundingClientRect().y < w - offset) {
                scrollInElement.setAttribute('data-scroll', 'in');
            } else {
                scrollInElement.setAttribute('data-scroll', 'out');
            }
        }
    }

}
